// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__MPvw5","card":"Cards_card__2N2xB","infected":"Cards_infected__AejAn","recovered":"Cards_recovered__16--6","deaths":"Cards_deaths__2DhQc"};